import { render, staticRenderFns } from "./progressbar.vue?vue&type=template&id=bca4d314&scoped=true&"
import script from "./progressbar.vue?vue&type=script&lang=js&"
export * from "./progressbar.vue?vue&type=script&lang=js&"
import style0 from "./progressbar.vue?vue&type=style&index=0&id=bca4d314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca4d314",
  null
  
)

export default component.exports